import { ICON__pen } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { md } from '@/utils/utils_html';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';

interface Props {
  setIsEditName: (value: boolean) => void;
  isSelected?: boolean;
}

export const U_BUTTON__user_task_change_name: React.FC<Props> = ({ setIsEditName, isSelected = false }) => {
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    setIsEditName(true);
  };

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_USER_TASK_UPDATE)) return <></>;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      className="w-7"
      size="square-5"
      variant="no-border-on-component"
      onClick={onClick}
      iconClassNameBase={`!w-3 !h-3 ${md(`${isSelected ? '!text-bar' : '!text-component-item-foreground '}`, ``)}`}
      iconClassNameHovered="!text-bar-foreground"
      iconClassNameNonHovered="!text-bar"
      Icon={ICON__pen}
    />
  );
};
